import { render, staticRenderFns } from "./AgentPermission.vue?vue&type=template&id=037ae4bc&scoped=true&"
import script from "./AgentPermission.vue?vue&type=script&lang=js&"
export * from "./AgentPermission.vue?vue&type=script&lang=js&"
import style0 from "./AgentPermission.vue?vue&type=style&index=0&id=037ae4bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "037ae4bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VDialog,
  VForm,
  VIcon,
  VSelect,
  VTextField,
})
